import * as types from './constants'
import {
  getDescendantIds,
  isSameFolder,
  normalizeLibraryItem,
  upsertInAllList,
  upsertInFolderList,
} from './libraryItems'

const initialState = {
  files: [],
  previousFiles: null,
  itemIndex: 0,
  showLibraryReorder: false,
  libraryLoaded: false,
  uploadVideoStatus: '',
  fileUploadStatus: '',
  libraryUploadPercent: 0,
  searchValue: '',
  title: '',
  parentId: null,
  overlayIsShowing: false,
  fileOverlayIsShowing: false,
  activeParentId: null,
  currentTab: 'category',
  scope: 'public',
  selectedOrgGroups: [],
  selectedUsers: [],
  selectedLocationGroups: [],
  selectedLocations: [],
  selectedStores: [],
  selectedRoles: [],
  selectedRoleGroups: [],
  selectedRole: null,
  isLoading: true,
  filesParents: [],
  parent: null,
  currentItems: 'groupOrgs',
  currentSelectedItems: 'selectedOrgGroups',
  currentToggleFunction: 'toggleOrgGroups',
  assignSearchValue: '',
  showSelectedOrgGroups: false,
  showSelectedUsers: false,
  showSelectedLocationGroups: false,
  showSelectedRoleGroups: false,
  showSelectedLocations: false,
  showSelectedStores: false,
  showSelectedRoles: false,
  currentHideSelectedItemsFunction: 'setHideSelectedOrgGroups',
  currentShowSelectedItemsFunction: 'setShowSelectedOrgGroups',
  currentShowSelectedItems: 'showSelectedOrgGroups',
  myFiles: [],
  selectedFolder: '',
  allFoldersNested: [],
  allFolders: [],
  allLibrary: [],
  libraryFolderRoles: [],
  filteredFilesIds: [],
}

const libraryReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.LIBRARY:
      return {
        ...state,
        files: action.data,
      }
    case types.SET_ITEM_INDEX:
      return {
        ...state,
        itemIndex: action.index,
      }

    case types.PRESENT:
      return {
        ...state,
        previousFiles: JSON.stringify(state.files),
      }
    case types.UNDO:
      return {
        ...state,
        files: JSON.parse(state.previousFiles),
      }
    case types.TOGGLE_LIBRARY:
      return {
        ...state,
        showLibraryReorder: action.payload,
      }

    case types.LOADING:
      return {
        ...state,
        [action.loadingType]: action.isLoading,
      }
    case types.UPLOAD_FILE_STATUS:
      return {
        ...state,
        fileUploadStatus: action.status,
      }
    case types.LIBRARY_UPLOAD_PERCENT:
      return {
        ...state,
        libraryUploadPercent: action.percent,
      }
    case types.SET_SEARCH_VALUE:
      return {
        ...state,
        searchValue: action.searchValue,
      }
    case types.SET_SEARCH_VALUE_ON_CLICK:
      return {
        ...state,
        searchValueOnClick: action.value,
      }
    case types.SET_FOLDER_TITLE:
      return {
        ...state,
        title: action.title,
      }
    case types.SET_ROLE_SELECTED:
      return {
        ...state,
        selectedRole: action.payload,
      }
    case types.SET_LIBRARY_FOLDER_ROLES:
      return {
        ...state,
        libraryFolderRoles: action.payload,
      }
    case types.RESET_TITLE:
      return {
        ...state,
        title: '',
      }
    case types.SET_PARENT_ID:
      return {
        ...state,
        parentId: action.parentId,
        // The folder picked in the add/update modals always starts from the folder
        // we're looking at, so it can never be left over from an earlier folder.
        selectedFolder: action.parentId ?? null,
      }
    case types.SET_PARENT_NAME:
      return {
        ...state,
        parentName: action.parentName,
      }
    case types.SET_OVERLAY_SHOWING:
      return {
        ...state,
        overlayIsShowing: action.overlayIsShowing,
      }
    case types.SET_FILE_OVERLAY_SHOWING:
      return {
        ...state,
        fileOverlayIsShowing: action.fileOverlayIsShowing,
      }
    case types.SET_FILE_SCOPE:
      return {
        ...state,
        scope: action.value,
      }
    case types.SET_CURRENT_TAB:
      return {
        ...state,
        currentTab: action.currentTab,
      }
    case types.SET_SELECTED_ORG_GROUPS:
      return {
        ...state,
        selectedOrgGroups: action.orgGroups,
      }
    case types.SET_FILES_PARENTS:
      return {
        ...state,
        filesParents: action.filesParents,
      }
    case types.SET_LIBRARY_ISLOADING:
      return {
        ...state,
        isLoading: action.isLoading,
      }
    case types.SET_PARENT:
      return {
        ...state,
        parent: action.data,
      }
    case types.SET_CURRENT_SELECTED_ITEMS:
      return {
        ...state,
        currentSelectedItems: action.currentSelectedItems,
      }
    case types.SET_CURRENT_ITEMS:
      return {
        ...state,
        currentItems: action.currentItems,
      }
    case types.SET_CURRENT_TOGGLE_ITEM_FUNCTION:
      return {
        ...state,
        currentToggleFunction: action.currentToggleFunction,
      }
    case types.SET_CURRENT_HIDE_SELECTED_ITEMS_FUNCTION:
      return {
        ...state,
        currentHideSelectedItemsFunction:
          action.currentHideSelectedItemsFunction,
      }
    case types.SET_CURRENT_SHOW_SELECTED_ITEMS_FUNCTION:
      return {
        ...state,
        currentShowSelectedItemsFunction:
          action.currentShowSelectedItemsFunction,
      }
    case types.SET_CURRENT_SHOW_SELECTED_ITEMS:
      return {
        ...state,
        currentShowSelectedItems: action.currentShowSelectedItems,
      }
    case types.SET_SELECTED_USERS:
      return {
        ...state,
        selectedUsers: action.users,
      }
    case types.SET_SELECTED_LOCATION_GROUPS:
      return {
        ...state,
        selectedLocationGroups: action.locationGroups,
      }
    case types.SET_SELECTED_ROLE_GROUPS:
      return {
        ...state,
        selectedRoleGroups: action.roleGroups,
      }
    case types.SET_SELECTED_LOCATIONS:
      return {
        ...state,
        selectedLocations: action.locations,
      }
    case types.SET_SELECTED_STORES:
      return {
        ...state,
        selectedStores: action.stores,
      }
    case types.SET_SELECTED_ROLES:
      return {
        ...state,
        selectedRoles: action.roles,
      }
    case types.RESET_SELECTED_ITEMS:
      return {
        ...state,
        selectedLocationGroups: [],
        selectedLocations: [],
        selectedStores: [],
        selectedOrgGroups: [],
        selectedRoles: [],
        selectedUsers: [],
        selectedRoleGroups: [],
      }
    case types.SET_ASSIGN_SEARCH_VALUE:
      return {
        ...state,
        assignSearchValue: action.assignSearchValue,
      }
    case types.SET_SHOW_SELECTED_ORG_GROUPS:
      return {
        ...state,
        showSelectedOrgGroups: action.showSelectedOrgGroups,
      }
    case types.SET_SHOW_SELECTED_USERS:
      return {
        ...state,
        showSelectedUsers: action.showSelectedUsers,
      }
    case types.SET_SHOW_SELECTED_LOCATION_GROUPS:
      return {
        ...state,
        showSelectedLocationGroups: action.showSelectedLocationGroups,
      }
    case types.SET_SHOW_SELECTED_ROLE_GROUPS:
      return {
        ...state,
        showSelectedRoleGroups: action.showSelectedRoleGroups,
      }
    case types.SET_SHOW_SELECTED_LOCATIONS:
      return {
        ...state,
        showSelectedLocations: action.showSelectedLocations,
      }
    case types.SET_SHOW_SELECTED_STORES:
      return {
        ...state,
        showSelectedStores: action.showSelectedStores,
      }
    case types.SET_SHOW_SELECTED_ROLES:
      return {
        ...state,
        showSelectedRoles: action.showSelectedRoles,
      }
    case types.SET_HOMEWORK_TITLE:
      return {
        ...state,
        title: action.title,
      }
    case types.SET_MY_DOCUMENTS:
      return {
        ...state,
        myFiles: action.data,
      }

    case types.SELECT_FOLDER:
      return {
        ...state,
        selectedFolder: action.id,
      }

    case types.FETCH_ALL_FOLDERS_NESTED:
      return {
        ...state,
        allFoldersNested: action.folders,
      }
    case types.FETCH_ALL_FOLDERS:
      return {
        ...state,
        allFolders: action.folders,
      }
    case types.ALL_LIBRARY:
      return {
        ...state,
        allLibrary: action.payload,
      }
    case types.SET_FILTERED_FILES_IDS:
      return {
        ...state,
        filteredFilesIds: action.payload,
      }

    // Apply saved items (add / edit / move) to the lists in place, no refetch.
    case types.UPSERT_LIBRARY_ITEMS: {
      let { files, allLibrary } = state

      action.items.forEach((rawItem) => {
        const patch = normalizeLibraryItem(rawItem)
        const previous =
          files.find((item) => item.id === patch.id) ||
          allLibrary.find((item) => item.id === patch.id) ||
          {}
        const item = { ...previous, ...patch }

        files = upsertInFolderList(
          files,
          item,
          isSameFolder(item.parent_id, state.parentId),
        )
        allLibrary = upsertInAllList(allLibrary, item)

        // Changing a folder's scope changes everything inside it too (same as the API).
        if (item.type === 'folder' && patch.scope) {
          const descendantIds = getDescendantIds(allLibrary, item.id)
          if (descendantIds.length) {
            const applyScope = (list) =>
              list.map((entry) =>
                descendantIds.includes(entry.id)
                  ? { ...entry, scope: patch.scope }
                  : entry,
              )
            files = applyScope(files)
            allLibrary = applyScope(allLibrary)
          }
        }
      })

      return { ...state, files, allLibrary }
    }

    case types.REMOVE_LIBRARY_ITEM: {
      const id = Number(action.id)
      const removedIds = [id, ...getDescendantIds(state.allLibrary, id)]
      const keep = (item) => !removedIds.includes(item.id)

      return {
        ...state,
        files: state.files.filter(keep),
        allLibrary: state.allLibrary.filter(keep),
      }
    }
    default:
      return state
  }
}

export default libraryReducer
